import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import * as IssueReportService from 'services/agents/issue-report';

export const useIssueReportService = () => {
  const { token } = useSelector((store) => store.user_data);

  const fetchIssueReports = async (options = {}) => {
    const { error, payload } = await IssueReportService.read({ ...options, token });
    if (error) {
      toast.error('Unable to fetch reports at this time.');
      return { reports: [], size: 0 };
    }

    const reports = payload?.data || payload?.reports || [];
    const size = payload?.meta?.size ?? reports.length;
    return { reports, size };
  };

  const createIssueReport = async (data, options = {}) => {
    const { silent = false, ...request_options } = options;
    const { error, payload } = await IssueReportService.create({ ...request_options, data, token });
    if (error) {
      if (!silent) toast.error(error || 'Unable to add issue to tenant at this time.');
      return { report: null };
    }

    if (!silent) toast.success('Issue added to tenant successfully.');
    const report = payload?.data || payload?.report || payload || null;
    return { report };
  };

  const updateReportStatus = async (id, status, options = {}) => {
    const { error, payload } = await IssueReportService.updateById(id, {
      ...options,
      data: { status },
      token
    });
    if (error) {
      toast.error(error || 'Unable to update report at this time.');
      return { report: null };
    }

    toast.success('Report updated successfully.');
    const report = payload?.data || payload?.report || payload || null;
    return { report };
  };

  return { fetchIssueReports, createIssueReport, updateReportStatus };
};
